"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cottagesSortOptions = exports.novasolSortOptions = exports.defaultSortOptions = void 0;
exports.defaultSortOptions = {
    dated: {
        default: 'priceasc',
        options: ['nosort', 'priceasc', 'pricedsc', 'reviewsdsc'],
    },
    undated: {
        default: 'priceasc',
        options: ['nosort', 'priceasc', 'pricedsc', 'reviewsdsc'],
    },
};
exports.novasolSortOptions = {
    dated: {
        default: 'bestmatch',
        options: ['bestmatch', 'priceasc', 'pricedsc', 'gradedsc'],
    },
    undated: {
        default: 'bestmatch',
        options: ['bestmatch', 'priceasc', 'pricedsc', 'gradedsc'],
    },
};
exports.cottagesSortOptions = {
    dated: {
        default: 'recommended',
        options: [
            'nosort',
            'priceasc',
            'pricedsc',
            'sleepsasc',
            'sleepsdsc',
            'reviewsdsc',
            'recommended',
        ],
    },
    undated: {
        default: 'recommended',
        options: ['nosort', 'sleepsasc', 'sleepsdsc', 'reviewsdsc', 'recommended'],
    },
};
//# sourceMappingURL=sortOptions.js.map